/* eslint-disable arrow-body-style */
/* eslint-disable no-console */
import React from 'react';
import { DropdownMenu } from '@abyss/web/ui/DropdownMenu';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { useToast } from '@abyss/web/hooks/useToast';
import { ResultsStatus } from '@src/common/types';
import { linkAnalysisId } from '../../types';
import {
  linkAnalysisResultsApi,
  useLinkAnalysisResultsStore,
} from '../../mothership/linkAnalysisResults.state';
import { downloadGraphToast } from '../../mothership/download/downloadGraphToast';

export const LaDownloadMenu = () => {
  const imgDownloadEnabled =
    useLinkAnalysisResultsStore((state) => state.resultStatus) ===
    ResultsStatus.results;
  const csvExportInProgress = useLinkAnalysisResultsStore(
    (state) => state.csvExportInProgress
  );

  downloadGraphToast.setToast(useToast().toast);
  const id = `${linkAnalysisId}DownloadTrigger`;
  return (
    <div data-testid={id} data-cy={id}>
      <DropdownMenu
        label="Download"
        before={<IconSymbol icon="download_2" />}
        after={<IconSymbol icon="keyboard_arrow_down" />}
        menuItems={[
          {
            title: 'Download full dataset (CSV)',
            onClick: linkAnalysisResultsApi.downloadCsv,
            icon: <IconSymbol icon="download_done" />,
            disabled: csvExportInProgress,
          },
          {
            title: 'Download image (PNG)',
            onClick: linkAnalysisResultsApi.downloadImg,
            icon: <IconSymbol icon="image" variant="outlined" />,
            disabled: !imgDownloadEnabled,
          },
        ]}
        css={{
          'abyss-dropdown-menu-content': {
            marginRight: 'var(--abyss-space-xl)',
          },
        }}
      />
    </div>
  );
};
